import { useEffect, useState } from "react";
import { osApi, formatINR } from "./osApi";
import { toast } from "sonner";
import { Plus, Handshake } from "lucide-react";

export default function OSConnectors() {
  const [items, setItems] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", city: "Hyderabad", partner_type: "Individual" });
  const [loading, setLoading] = useState(true);

  const load = () => osApi.listConnectors().then(r => setItems(r.items)).catch(() => toast.error("Failed")).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await osApi.createConnector(form); toast.success("Connector added"); setShowAdd(false); setForm({ name:"", phone:"", email:"", city:"Hyderabad", partner_type:"Individual" }); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-5" data-testid="os-connectors-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Connectors</h1>
          <p className="text-sm mt-1" style={{color:"var(--os-text-muted)"}}>DSA network — leads, closures & payouts per partner.</p>
        </div>
        <button onClick={() => setShowAdd(true)} className="os-btn" data-testid="os-add-connector"><Plus className="w-3.5 h-3.5" /> Add connector</button>
      </div>

      <div className="os-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="os-table">
            <thead><tr><th>Name</th><th>Type</th><th>Phone</th><th>City</th><th>Leads</th><th>Closed</th><th>Revenue</th><th>Payout</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan={8} className="text-center py-10" style={{color:"var(--os-text-muted)"}}>Loading…</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={8} className="text-center py-10" style={{color:"var(--os-text-muted)"}}>No connectors yet.</td></tr>}
              {items.map(c => (
                <tr key={c.id} data-testid={`os-connector-row-${c.name}`}>
                  <td className="font-medium">{c.name}</td>
                  <td><span className="os-badge os-badge-blue">{c.partner_type}</span></td>
                  <td className="os-mono text-xs">{c.phone}</td>
                  <td>{c.city}</td>
                  <td className="os-mono">{c.leads_given}</td>
                  <td className="os-mono" style={{color: c.deals_closed > 0 ? "var(--os-green)" : "inherit"}}>{c.deals_closed}</td>
                  <td className="os-mono">{formatINR(c.revenue)}</td>
                  <td className="os-mono">{formatINR(c.payout)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showAdd && (
        <div className="os-drawer-overlay" onClick={() => setShowAdd(false)}>
          <div className="os-drawer" onClick={e => e.stopPropagation()}>
            <form onSubmit={add} className="p-6 space-y-4" data-testid="os-connector-form">
              <div className="flex items-center gap-2"><Handshake className="w-4 h-4" /> <h3 className="text-lg font-bold">Add Connector</h3></div>
              <Input label="Name" value={form.name} onChange={v => setForm({...form, name: v})} required testid="os-connector-name" />
              <Input label="Phone" value={form.phone} onChange={v => setForm({...form, phone: v})} required testid="os-connector-phone" />
              <Input label="Email" value={form.email} onChange={v => setForm({...form, email: v})} testid="os-connector-email" />
              <Input label="City" value={form.city} onChange={v => setForm({...form, city: v})} testid="os-connector-city" />
              <label className="block">
                <div className="text-xs mb-1" style={{color:"var(--os-text-muted)"}}>Type</div>
                <select className="os-input" value={form.partner_type} onChange={e => setForm({...form, partner_type: e.target.value})}>
                  <option>Individual</option><option>Agency</option><option>DSA</option>
                </select>
              </label>
              <div className="flex gap-2 pt-2">
                <button type="submit" className="os-btn" data-testid="os-connector-save">Save</button>
                <button type="button" onClick={() => setShowAdd(false)} className="os-btn-ghost">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function Input({ label, value, onChange, required, testid }) {
  return (
    <label className="block">
      <div className="text-xs mb-1" style={{color:"var(--os-text-muted)"}}>{label}{required && " *"}</div>
      <input className="os-input" value={value} onChange={e => onChange(e.target.value)} required={required} data-testid={testid} />
    </label>
  );
}
